module.exports = __webpack_public_path__ + "static/img/cover-picture-icon.770c73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover-picture-icon.png
// module id = cR2b
// module chunks = 7